import { combineEpics } from "redux-observable";

import userSessionEpics from "../components/login/userSession.epic";
// import subscriptionFormEpics from '../components/subscriptionForm/subscriptionForm.epic';
// import spectreAppEpics from '../components/spectreApp/spectreApp.epic';
// import sideBarEpics from '../components/sideBar/sideBar.epic';
import settingsEpics from "../components/settings/settings.epic";
import specsheetEpics from "../components/specsheet/specsheet.epic";
import bowlersEpics from "../components/bowlers/bowlers.epic";
import arsenalEpics from "../components/arsenal/arsenal.epic";
import dashboardEpics from "../components/dashboard/dashboard.epic";
import pluginEpics from "../components/plugins/plugin.epic";
import devicesEpics from "../components/devices/devices.epic";
// import syncDeviceModalEpics from '../components/syncDeviceModal/syncDeviceModal.epic';
// import importLoginFormEpics from '../components/ImportPSM/ImportLoginForm.epic';
// import importPSMEpics from '../components/ImportPSM/ImportPSM.epic';

export const epics = combineEpics(
  userSessionEpics,
  // subscriptionFormEpics,
  // spectreAppEpics,
  // sideBarEpics,
  settingsEpics,
  specsheetEpics,
  bowlersEpics,
  arsenalEpics,
  dashboardEpics,
  pluginEpics,
  devicesEpics,
  // syncDeviceModalEpics,
  // importLoginFormEpics,
  // importPSMEpics
);
